export default {
  dialogControls: {},
};
